export const COMMERCIAL_SEARCH = {
  PROVIDER: {
    search_type: 'issuer',
  },
  PLAN: {
    search_type: 'plans',
  },
  DRUG: {
    search_type: 'drugs',
  },
};
